<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-content" :style="[props.service.integration_name != 'slack' ? { width: 'fit-content', 'min-width': '40rem', 'max-width': '90vw' } : {}]">
      <div class="is-flex is-flex-direction-column is-justify-content-space-between has-background-white px-5 py-4" style="border-radius: 1.5rem;height:100%">
        <slot></slot>
      </div>
    </div>
    <button class="modal-close is-large" aria-label="close" @click="close"></button>
  </div>
</template>

<script setup>
const emit = defineEmits(['closed'])
const props = defineProps(['service'])

function close() {
  emit('closed');
}

</script>

<style scoped>
 .action-button:hover {
   box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
 }
</style>
